<template>
    <v-dialog v-model="dialog">
      <v-layout class="fill-height" fluid>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 elevation-0>
            <v-card>
              <v-toolbar>
                <v-toolbar-title>Reset Password</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-layout row>
                  Please provide your username that is registered with us and press the reset password button. An email with a link will be sent to you that will allow you to change your password.
                </v-layout>
                <v-form v-model="valid"  ref="resetForm" lazy-validation>
                  <v-layout row>
                    <v-text-field
                      prepend-icon="fa-user"
                      label="Email Address"
                      v-model="Email"
                      :rules="emailRules"
                      required
                    ></v-text-field>
                  </v-layout>
                  <v-layout class="buttons" justify-end row align-center>
                    <a style="text-decoration: none"
                          class="align-center mr-4"
                          @click="cancel">
                      CANCEL
                    </a>
                    <v-btn color="success" 
                        class="ml-2 mr-4" 
                        @click="submitForm"
                        :disabled="!valid">
                      Reset Password
                    </v-btn>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-dialog>
</template>

<script>
import axios from "axios";
import Bus from "../bus";

export default {
    name: "ForgotPassword",
    valid: true,

    data: () =>({
        Email: null,
        dialog: false,
        valid: false,

        emailRules: [ 
            v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email must be valid'
        ],
    }),

    methods: {
        submitForm(){
            // Check the form was valid
            if(this.$refs.resetForm.validate())
            {
              // Post the request to API
              axios.post('api/User/ResetPassword',{ "Email": this.Email })
              .catch(error => {
                console.log(error);
                this.cancel();
                return;
              })

              this.dialog = false;
              
              Bus.$emit("alert", {
              color: "success",
              message: "Password reset request sent!"
              });
            }
        },

        async open(){
            this.dialog = true;
        },

        cancel(){
            this.dialog = false;
        },
    },
}
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

